(function () {
  function formatMoney(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      this.minItems = parseInt(this.dataset.minItems, 10) || 3;
      this.discountPercent = parseFloat(this.dataset.discountPercent) || 0;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.discountCode = this.dataset.discountCode || '';
      /* Corte 30% -> 3x2. Se evalua en el cliente para que una pagina cacheada
         antes del corte tambien calcule el precio correcto. */
      this.switchTs = parseInt(this.dataset.switchTs, 10) || 0;
      this.is3x2 = this.switchTs > 0 && (Date.now() / 1000) >= this.switchTs;
      this.state = new Map();

      this.grid = this.querySelector('[data-bundle-grid]');
      this.slotsWrap = this.querySelector('[data-bundle-slots]');
      this.totalEl = this.querySelector('[data-bundle-total]');
      this.compareEl = this.querySelector('[data-bundle-compare]');
      this.submitBtn = this.querySelector('[data-bundle-submit]');
      this.submitText = this.querySelector('[data-bundle-submit-text]');
      this.errorEl = this.querySelector('[data-bundle-error]');

      if (!this.grid || !this.submitBtn) return;

      this.grid.addEventListener('click', this.onGridClick.bind(this));
      if (this.slotsWrap) this.slotsWrap.addEventListener('click', this.onSlotsClick.bind(this));
      this.submitBtn.addEventListener('click', this.onSubmit.bind(this));

      this.renderSlots();
      this.renderTotals();
    }

    onGridClick(event) {
      var addBtn = event.target.closest('[data-bundle-add]');
      var minus = event.target.closest('[data-bundle-minus]');
      var plus = event.target.closest('[data-bundle-plus]');
      if (!addBtn && !minus && !plus) return;

      var item = event.target.closest('[data-variant-id]');
      if (!item) return;
      var variantId = item.dataset.variantId;

      if (addBtn) {
        this.addVariant(item);
      } else if (plus) {
        this.incrementVariant(variantId);
      } else if (minus) {
        this.decrementVariant(variantId);
      }

      this.renderSlots();
      this.renderTotals();
    }

    onSlotsClick(event) {
      var removeBtn = event.target.closest('[data-slot-remove]');
      if (!removeBtn) return;
      this.decrementVariant(removeBtn.dataset.slotRemove);
      this.renderSlots();
      this.renderTotals();
    }

    addVariant(item) {
      var image = item.querySelector('img');
      var variantId = item.dataset.variantId;
      this.state.set(variantId, {
        qty: 1,
        price: parseInt(item.dataset.price, 10) || 0,
        title: item.dataset.title || '',
        image: image ? image.src : ''
      });
      this.syncItemUI(variantId);
    }

    incrementVariant(variantId) {
      var entry = this.state.get(variantId);
      if (!entry) return;
      entry.qty += 1;
      this.state.set(variantId, entry);
      this.syncItemUI(variantId);
    }

    decrementVariant(variantId) {
      var entry = this.state.get(variantId);
      if (!entry) return;
      entry.qty -= 1;
      if (entry.qty <= 0) {
        this.state.delete(variantId);
      } else {
        this.state.set(variantId, entry);
      }
      this.syncItemUI(variantId);
    }

    syncItemUI(variantId) {
      var item = this.grid.querySelector('[data-variant-id="' + variantId + '"]');
      if (!item) return;
      var entry = this.state.get(variantId);
      var addBtn = item.querySelector('[data-bundle-add]');
      var stepper = item.querySelector('[data-bundle-stepper]');
      var qtyEl = item.querySelector('[data-bundle-qty]');
      if (entry) {
        addBtn.hidden = true;
        stepper.hidden = false;
        qtyEl.textContent = entry.qty;
      } else {
        addBtn.hidden = false;
        stepper.hidden = true;
      }
    }

    getTotalQty() {
      var total = 0;
      this.state.forEach(function (entry) {
        total += entry.qty;
      });
      return total;
    }

    renderSlots() {
      if (!this.slotsWrap) return;
      var totalQty = this.getTotalQty();
      var slotCount = Math.max(this.minItems, Math.ceil((totalQty + 1) / this.minItems) * this.minItems);
      if (totalQty === 0) slotCount = this.minItems;

      var filled = [];
      this.state.forEach(function (entry, variantId) {
        for (var i = 0; i < entry.qty; i++) {
          filled.push({ variantId: variantId, title: entry.title, image: entry.image });
        }
      });

      this.slotsWrap.innerHTML = '';
      for (var i = 0; i < slotCount; i++) {
        var slot = document.createElement('div');
        slot.className = 'bundle-builder__slot';
        if (filled[i]) {
          slot.classList.add('bundle-builder__slot--filled');
          var mediaHtml = filled[i].image
            ? '<div class="bundle-builder__slot-media"><img src="' + filled[i].image + '" alt="" width="80" height="80"></div>'
            : '';
          slot.innerHTML =
            '<button type="button" class="bundle-builder__slot-remove" data-slot-remove="' +
            filled[i].variantId +
            '" aria-label="Quitar ' +
            filled[i].title +
            '">&times;</button>' +
            mediaHtml +
            '<span class="bundle-builder__slot-title">' + filled[i].title + '</span>';
        } else {
          slot.innerHTML =
            '<span class="bundle-builder__slot-number">' +
            (i + 1) +
            '</span><span class="bundle-builder__slot-title">Producto ' +
            (i + 1) +
            '</span>';
        }
        this.slotsWrap.appendChild(slot);
      }
    }

    /* 3x2: de cada 3 articulos, el mas barato va gratis. Replica la regla del
       descuento automatico de Shopify ("Compra 2 y llevate 1 gratis", que libera
       las unidades mas baratas). Tiene que dar exactamente igual que el carrito,
       o el cliente ve un precio aqui y otro en el checkout. */
    total3x2() {
      var prices = [];
      this.state.forEach(function (entry) {
        for (var i = 0; i < entry.qty; i++) prices.push(entry.price);
      });
      prices.sort(function (a, b) { return a - b; });
      var freeCount = Math.floor(prices.length / 3);
      var total = 0;
      for (var i = 0; i < prices.length; i++) {
        if (i >= freeCount) total += prices[i];
      }
      return total;
    }

    renderTotals() {
      var totalQty = this.getTotalQty();
      var subtotal = 0;
      this.state.forEach(function (entry) {
        subtotal += entry.price * entry.qty;
      });

      var eligible = totalQty >= this.minItems;
      var finalTotal = eligible
        ? (this.is3x2 ? this.total3x2() : Math.round(subtotal * (1 - this.discountPercent / 100)))
        : subtotal;

      if (this.totalEl) this.totalEl.textContent = formatMoney(finalTotal, this.moneyFormat);

      if (this.compareEl) {
        if (eligible && (this.is3x2 || this.discountPercent > 0)) {
          this.compareEl.textContent = formatMoney(subtotal, this.moneyFormat);
          this.compareEl.hidden = false;
        } else {
          this.compareEl.hidden = true;
        }
      }

      if (this.submitBtn) this.submitBtn.disabled = totalQty < this.minItems;

      if (this.submitText) {
        if (totalQty === 0) {
          this.submitText.textContent = 'Elige ' + this.minItems + ' o más productos';
        } else if (totalQty < this.minItems) {
          var remaining = this.minItems - totalQty;
          this.submitText.textContent = this.is3x2
            ? 'Elige ' + remaining + ' más y pagas solo 2'
            : 'Elige ' + remaining + ' más para ahorrar ' + this.discountPercent + '%';
        } else {
          this.submitText.textContent = this.is3x2
            ? 'Agregar al carrito · 3x2'
            : 'Agregar al carrito y ahorrar ' + this.discountPercent + '%';
        }
      }
    }

    onSubmit() {
      if (this.submitBtn.disabled) return;
      if (this.errorEl) this.errorEl.hidden = true;
      this.submitBtn.classList.add('loading');
      this.submitBtn.disabled = true;

      var items = [];
      this.state.forEach(function (entry, variantId) {
        items.push({ id: parseInt(variantId, 10), quantity: entry.qty });
      });

      var self = this;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status) {
            throw new Error(data.description || 'No se pudo agregar el bundle al carrito');
          }
          /* En modo 3x2 NO se aplica ningun codigo: lo resuelve el descuento
             automatico "3x2 Productos Individuales". Ese descuento es no
             combinable, asi que aplicar aqui el codigo del 30% lo bloquearia
             y el cliente terminaria pagando de mas. */
          if (self.discountCode && !self.is3x2) {
            window.location.href = '/discount/' + encodeURIComponent(self.discountCode) + '?redirect=/cart';
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (error) {
          self.submitBtn.classList.remove('loading');
          self.submitBtn.disabled = false;
          if (self.errorEl) {
            self.errorEl.textContent = error.message;
            self.errorEl.hidden = false;
          }
        });
    }
  }

  if (!customElements.get('bundle-builder')) {
    customElements.define('bundle-builder', BundleBuilder);
  }
})();
